<svg *ngIf="pumpSet" [attr.width]="pumpSetSvgService.pumpSetWidth(pumpSet,true)"
[attr.height]="pumpSetSvgService.pumpSetHeight(pumpSet,100,true)">
    <g lib-pumpset-svg
          [pumpSetObj]="pumpSet"
          [ltx]="0"
          [lty]="0"
          [pipeLengthRatio]="100"
          [detailedDiagram]="true"
          [lighterStyle]="false"
          [drawBoundingBox]="false"
          [selectableComponents]="true"></g>
</svg>
